export default "__VITE_ASSET__4363ae33__"